import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { Routes, RouterModule } from '@angular/router';
import { RegisterComponent } from './register/register.component';
import { LoginComponent } from './login/login.component';
import { ModuleWithProviders } from '@angular/core';
import { ActivateUserComponent } from './activate-user/activate-user.component';
import { ChangePasswordComponent } from '../settings/change-password/change-password.component';
import { RegistrationSuccessComponent } from './registration-success/registration-success.component';
import { LoginAsComponent } from './login-as/login-as.component';


const routes: Routes = [
    {
      path: 'register', component: RegisterComponent,  data: { activeClass: 'new-login',title:"Register - Provider Portal" }
    
    },
    { path: 'login', component: LoginComponent , data: { activeClass: 'new-login',title:"Login - Provider Portal" }},
    { path: 'changepassword', component: ChangePasswordComponent , data: { activeClass: '',title:"Login - Provider Portal" }},
    { path: 'forgotpassword', component: ForgotPasswordComponent , data: { activeClass: 'new-login',title:"Login - Provider Portal" }},
    { path: 'activateuser/:token', component: ActivateUserComponent , data: { activeClass: 'new-login',title:"Login - Provider Portal" }},
    { path: 'registration/success', component: RegistrationSuccessComponent , data: { activeClass: 'new-login',title:"Login - Provider Portal" }},
    {
      path: 'authenticateuser/:token', component: LoginAsComponent,
      data: { activeClass: 'hose', showFooter: false}
    },
  
    
  ];
  
  export const AuthenticationRoutingModule: ModuleWithProviders = RouterModule.forChild(routes);